import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=66f3491c&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=66f3491c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f3491c",
  null
  
)

export default component.exports